import { frontendURL } from '../../../helper/URLHelper';
import Branches from './Index.vue';
import ViewBranch from './components/viewBranch.vue';
import store from '../../../store/index';
import { subscriptionGuard } from '../../../helper/subscriptionHelper';
import { isOrganizationAccount } from '../../../helper/organizationAccessHelper';
import { withRealEstateRedirect } from '../../../helper/moduleGuards';

// Guard to restrict organization accounts from accessing branches
const branchesGuardInner = async (to, from, next) => {
  const accountId = to.params.accountId;

  // Redirect organization accounts to organization instead
  if (isOrganizationAccount(store, accountId)) {
    return next({ name: 'dashboard' });
  }

  // Check subscription for other accounts
  await subscriptionGuard(to, from, next, store);
};

// Real Estate accounts manage their own listings under real_estate/ —
// redirect them away from the old Branches page rather than showing both.
const branchesGuard = withRealEstateRedirect(branchesGuardInner, store);

export default {
  routes: [
    {      path: frontendURL('accounts/:accountId/branches'),
      name: 'branches',
      component: Branches,
      meta: {
        permissions: ['administrator', 'restricted', 'service_agent'],
      },
      beforeEnter: branchesGuard,
    },
    {      path: frontendURL('accounts/:accountId/branches/:branchId'),
      name: 'viewBranch',
      component: ViewBranch,
      meta: {
        permissions: ['administrator', 'restricted', 'service_agent'],
      },
      beforeEnter: branchesGuard,
    },
  ],
};
